import { createTheme } from "@mui/material/styles";

export const orgThemes = {
  org_1198: createTheme({
    custom: {
      primary: { main: "#39659A" },
    },
  }),
  org_194: createTheme({
    custom: {
      primary: { main: "#39659A" },
    },
  }),
  org_37: createTheme({
    custom: {
      primary: { main: "#39659A" },
    },
  }),
  org_1206: createTheme({
    custom: {
      primary: { main: "#39659A" },
    },
  }),
};
